import { lazy } from "react";

/* React.lazy for route pages, with one guard. A deploy replaces the hashed chunk
   files, so a tab (or installed PWA) opened BEFORE it asks for chunk names that
   no longer exist and the import rejects. Reloading once fetches the new index
   and the new names. The timestamp stops a genuinely broken chunk from looping. */
export function lazyRetry(factory) {
  return lazy(() =>
    factory().catch((err) => {
      try {
        const k = "rx-chunk-reload-at";
        const last = Number(sessionStorage.getItem(k) || 0);
        if (Date.now() - last > 15000) {
          sessionStorage.setItem(k, String(Date.now()));
          window.location.reload();
          return new Promise(() => {});
        }
      } catch { /* storage blocked: fall through to the error boundary */ }
      throw err;
    })
  );
}
